import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { B08aAgedBalancePage } from '../b08a-aged-balance/b08a-aged-balance';
import { B08bClientBillingPage } from '../b08b-client-billing/b08b-client-billing';
import { B08cFleetTransactionPage } from '../b08c-fleet-transaction/b08c-fleet-transaction';
import { B08dOutstandingInvoicePage } from '../b08d-outstanding-invoice/b08d-outstanding-invoice';
import { B08eInvoiceSummaryPage } from '../b08e-invoice-summary/b08e-invoice-summary';
import { B08fSalesDetailPage } from '../b08f-sales-detail/b08f-sales-detail';
import { B08gShiftSalesPage } from '../b08g-shift-sales/b08g-shift-sales';
import { B08hInventoryPage } from '../b08h-inventory/b08h-inventory';
import { B08iInventoryMovementPage } from '../b08i-inventory-movement/b08i-inventory-movement';
import { B08jFuelPricePage } from '../b08j-fuel-price/b08j-fuel-price';
import { B08kPoPage } from '../b08k-po/b08k-po';
import { B08lGoodReceivePage } from '../b08l-good-receive/b08l-good-receive';
import { B08mWantokPointPage } from '../b08m-wantok-point/b08m-wantok-point';
import { B08nWantokGiftcardSalesDetailPage } from '../b08n-wantok-giftcard-sales-detail/b08n-wantok-giftcard-sales-detail'; //[TCG:28/07/2020:CR/MB/20-02]:Added

/**
 * Generated class for the B08ReportManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b08-report-management',
  templateUrl: 'b08-report-management.html',
})
export class B08ReportManagementPage {
  GRP_ID:any;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }
  branchid:any;
  corpid:any;
  ionViewDidLoad() {
    console.log('ionViewDidLoad B08ReportManagementPage');
    this.branchid = sessionStorage.getItem('userbranchid');
    this.corpid = sessionStorage.getItem('usercorpid');
    this.GRP_ID = sessionStorage.getItem('usergroupid');
    console.log( this.GRP_ID);
    console.log("COPR_ID"+this.corpid);
    console.log("branchid"+this.branchid);
  }

  goToAgedBalace(){
    this.navCtrl.push(B08aAgedBalancePage);
  }

  goToClientBilling(){
    this.navCtrl.push(B08bClientBillingPage);
  }

  goToFleetTransaction(){
    this.navCtrl.push(B08cFleetTransactionPage);
  }

  goToOutstandingInvoice(){
    this.navCtrl.push(B08dOutstandingInvoicePage);
  }

  goToInvoiceSummary(){
    this.navCtrl.push(B08eInvoiceSummaryPage);
  }

  goToSalesDetail(){
    this.navCtrl.push(B08fSalesDetailPage);
  }

  //[TCG:28/07/2020:CR/MB/20-02]:Added
  goToWantokGCSalesDetail(){
    this.navCtrl.push(B08nWantokGiftcardSalesDetailPage);
  }

  goToShiftSales(){
    this.navCtrl.push(B08gShiftSalesPage);
  }

  goToInventory(){
    this.navCtrl.push(B08hInventoryPage);
  }
  goToInventoryMV(){
    this.navCtrl.push(B08iInventoryMovementPage);
  }

  goToFuelPrice(){
    this.navCtrl.push(B08jFuelPricePage);
  }

  goToPO(){
    this.navCtrl.push(B08kPoPage);
  }

  goToGR(){
    this.navCtrl.push(B08lGoodReceivePage);
  }
  
  goToWantok(){
    this.navCtrl.push(B08mWantokPointPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/b08-report-management/b08-report-management.ts